import { render, staticRenderFns } from "./SupportingDocumentUpload.vue?vue&type=template&id=44556816&scoped=true&"
import script from "./SupportingDocumentUpload.vue?vue&type=script&lang=js&"
export * from "./SupportingDocumentUpload.vue?vue&type=script&lang=js&"
import style0 from "./SupportingDocumentUpload.vue?vue&type=style&index=0&id=44556816&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44556816",
  null
  
)

export default component.exports